"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpritesheetParser = void 0;
const pixi_js_1 = require("pixi.js");
class SpritesheetParser {
    constructor() {
        this.priority = 2;
    }
    static fromJSON(data, loader, resource) {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            const baseURL = resource.request.url.replace(/[^/]+$/, '');
            const imageResource = yield loader.add(`${resource.name}_image`, `${baseURL}/${data.meta.image}`).wait();
            const spritesheet = new pixi_js_1.Spritesheet(imageResource.texture, data, resource.request.url);
            spritesheet.parse(() => resolve(spritesheet));
        }));
    }
    use(resource, loader) {
        return __awaiter(this, void 0, void 0, function* () {
            if (resource.json && resource.json.frames) {
                resource.spritesheet = yield SpritesheetParser.fromJSON(resource.json, loader, resource);
            }
        });
    }
}
exports.SpritesheetParser = SpritesheetParser;
